import React, { useState, useEffect, useContext, useCallback,  } from "react";
import moment from 'moment';
import { Button, Table, notification, Input, DatePicker } from "antd";
import { SearchOutlined, CheckCircleOutlined, CloseCircleOutlined} from "@ant-design/icons";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import { v4 as uuidv4 } from "uuid";
import LoadingModal from "../../utils/LoadingModal";
import { Link } from "react-router-dom";

const PAGE_SIZE = 15;
const { RangePicker } = DatePicker;

const DecisionListTable = () => {
  const globals = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
  });
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState("");

  const columns = [
    {
      title: "Titulo",
      dataIndex: "pointName",
      key: "pointName",
      render: (_, record) => {
        if (record.parentPointName !== null)
          return (
            <p>{record.parentPointName} / {record.pointName}</p>
          )
        else
          return (
            <p>{record.pointName}</p>
          )
      }
    },
    {
      title: "Estado de éxito",
      dataIndex: "pointName",
      key: "pointName",
      render: (_, record) => {
        if (record?.agreement?.successful !== null) {
          if (record?.agreement?.successful) {
            return (
              <p>
           <CheckCircleOutlined style={{ color: 'green' }} /> <span>Exitoso</span>
              </p>
            );
          } else {
            return (
              <p>
          <CloseCircleOutlined style={{ color: 'red' }} /> <span>No exitoso</span> 
              </p>
            );
          }
        } else {
          return (
            <p>
              <CloseCircleOutlined style={{ color: 'red' }} /> <span>No exitoso</span> 
            </p>
          );
        }
      },
    },
    {
      title: "Responsable de seguimiento de éxito",
      dataIndex: ["agreement", "responsible"],
      key: "department",
    },
    {
      title: "Fecha acordada de éxito",
      dataIndex: "meetingSuccessDate",
      key: "meetingSuccessDate",
      render: (_, record) => {
        if (record.agreement.date !== null)
          return (
            moment(record.agreement.date).format("DD-MMM-YYYY")
          )
        else
          return (
            <p>Sin fecha</p>
          )
      }
    },
    {
      title: "Reunión asociada",
      dataIndex: ["meeting", "meeting_name"],
      key: "meeting_type",
      render: (_, record) => {
        return (
          <Link to={`/meeting/${record.meeting.id}/execute`}>{record.meeting.meeting_name}</Link>
        )
      }
    },
    // {
    //   title: "Opciones",
    //   key: "actions",
    //   width: 80,
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <Dropdown
    //         trigger={["click"]}
    //         menu={{
    //           items:[
    //             {
    //               key: '1',
    //               label: 'Editar',
    //               icon:<EditOutlined />,
    //               onClick: () => handleActionClick("edit", record)
    //             },
    //           ],
    //         }}
    //       >
    //         <Button icon={<DownOutlined />} shape="circle" />
    //       </Dropdown>
    //     </Space>
    //   ),
    // },
  ];

  const fetchData = useCallback(
    async (newPagination, search, startDate, endDate) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        let params = {
            page,
            limit: pageSize,
            search: search,
            agreementDate_from: (startDate) ? moment(startDate).format("YYYY-MM-DD") : null,
            agreementDate_to: (endDate) ? moment(endDate).format("YYYY-MM-DD") : null,
          }
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-approved-decisions-closed`,
          {
            headers: {
              "x-token": globals.token,
            },
            params,
          }
        );
        if (response.data.status !== 0){
          setLoading(false);
          return;
        }
        console.log("Data***********:", response?.data?.data?.rows);
        setData(response?.data?.data?.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data?.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data?.count,
          }
          );
        }
        notification.success({
          message: "Información obtenida exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.log("Error fetching data:", error.response);
        if (error?.response?.data?.status !== -3) {
          console.error("Error fetching data:", error.response);
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
            duration: 2,
          });
        }
        else{
          notification.warning({
            message: "No hay reuniones disponibles!",
            placement: "bottomRight",
            duration: 2,
          });
        
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  useEffect(() => {
    fetchData(null, null, 1, null, null);
  }, [fetchData]);

  async function handleTableChange(newPagination) {
    fetchData(newPagination, searchText, dateRange?.start, dateRange?.end);
  }

  const handleRefresh = () => {
    fetchData(null, searchText, dateRange?.start, dateRange?.end);
  };

  const handleSearch = async () => {
    console.log("searchText", searchText); 
    console.log("dateRange", dateRange);

    fetchData(null, searchText, dateRange?.start, dateRange?.end);
  };

  const handleSearchEnterKey = async (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <h2 style={{ marginRight: "16px" }}>Listado decisiones aprobadas cerradas</h2>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        <Button
          onClick={handleRefresh}
          disabled={loading}
          style={{ marginRight: "8px" }}
        >
          Refrescar
        </Button>
      </div>
      <Input
        placeholder="Buscar"
        allowClear
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: 16, width: 200 }}
        prefix={<SearchOutlined />}
        onKeyDown={handleSearchEnterKey}
      />
      <RangePicker
        style={{ marginBottom: 16, width: 200 }}
        onChange={(date, dateString) => {
          if (dateString[0] === "" || dateString[0] === null) {
            setDateRange("");
          }
          else{
            const startTimestamp = new Date(`${dateString[0]}T00:00:00Z`).getTime();
            const endTimestamp = new Date(`${dateString[1]}T23:59:59Z`).getTime();
            setDateRange({start: startTimestamp, end: endTimestamp});
          }
        }}
      />
      
      <Button onClick={handleSearch} style={{ marginRight: "8px" }}>
        Buscar
      </Button>
      <div
        className="site-layout-background h-auto"
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          margin: 0,
          height: "auto",
          minHeight: "350px",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <Table
          rowKey={(r) => uuidv4()}
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      </div>
      <LoadingModal open={loading} />    
    </div>
  );
};

export default DecisionListTable;
